import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ProjectCommunicationService } from '../../communication/project-comms.service';
import { Project } from '../../models/project/project.model';
import { InputSummaryItem } from '../../models/input-summary';
import { takeUntil, takeWhile } from 'rxjs/operators';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'app-input-summary',
  templateUrl: './input-summary.component.html',
  styleUrls: ['./input-summary.component.scss']
})
export class InputSummaryComponent extends UserpilotReloader implements OnInit, OnDestroy {
  project = new Project();
  onDestroyNotifier = new EventEmitter();

  dataSource;

  tables: TableItem[] = [];
  Object = Object;

  constructor(private projectCommService: ProjectCommunicationService) {
    super();
  }

  ngOnInit() {
    this.projectCommService.projectFullyLoadedNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .pipe(takeWhile(x => !x, true))
      .subscribe(loaded => {
        if (loaded) {
          this.project = this.projectCommService.getProject();
          this.dataSource = this.project.getInputSummary();
        }
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }
}

class TableItem {
  header = '';
  inputs: InputSummaryItem[] = [];

  constructor(header: string, inputs: InputSummaryItem[]) {
    this.header = header;
    this.inputs = inputs;
  }
}
